import CircularProgress from '@material-ui/core/CircularProgress'
import withStyles from '@material-ui/core/styles/withStyles'
import { getStyles } from 'isotope-client'
import React from 'react'
import LoaderAdvanced from 'react-loader-advanced'

const styles = () => getStyles({
	container: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: '4rem',
		width: '100%',
		zIndex: 100,
		background: 'linear-gradient(180deg, ' +
			'rgba(133,133,133,0.4) 0%, ' +
			'rgba(133,133,133,0.3) 35%, ' +
			'rgba(133,133,133,0) 100%)'
	},
	loader: {
		'& .Loader__message': {
			transform: 'translate(0, 0.5rem)'
		}
	},
	containerBottom: {
		background: 'linear-gradient(0, ' +
			'rgba(133,133,133,0.4) 0%, ' +
			'rgba(133,133,133,0.3) 35%, ' +
			'rgba(133,133,133,0) 100%)',
		top: 'unset',
		bottom: 0
	}
})
const FloatingLoader = ({ isBottom, isLoading, classes }) => isLoading &&
	<div className={`${classes.container} ${isBottom && classes.containerBottom}`}>
		<LoaderAdvanced
			show={isLoading}
			message={<CircularProgress size={30}/>}
			className={classes.loader}
			backgroundStyle={{ backgroundColor: 'rgba(255,255,255,0)' }}
		/>
	</div>


FloatingLoader.propType = {}

export default withStyles(styles)(FloatingLoader)